import React, { useState, useEffect } from "react";
import { FiUser, FiCalendar, FiHash, FiCheckCircle, FiPhone } from "react-icons/fi";

import InputField from "../../../ResuableCompoment/InputField";
import SelectField from "../../../ResuableCompoment/SelectField";
import Popup from "../../../ResuableCompoment/Popup";
import useApi from "../../../CustomHooks/useApi";

const BasicDetails = ({ data, onUpdate }) => {
  const [panVerified, setPanVerified] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  const [popup, setPopup] = useState({
    show: false,
    message: "",
  });

  const { callApi: panverify } = useApi(
    "/staff/onboard/verify-pan",
    "POST"
  );

    useEffect(() => {
    if (data?.panNumber && data?.fullName) {
      setPanVerified(true);
    }
  }, [data.panNumber, data.fullName]);

  /* ------------------ CHANGE HANDLER ------------------ */

  const handleChange = (e) => {
    const { name, value } = e.target;
    onUpdate({ ...data, [name]: value });
  };

  /* ------------------ PAN VERIFY ------------------ */

  const handlePanVerify = async () => {
    if (!data.panNumber || data.panNumber.length !== 10) {
      setPopup({
        show: true,
        message: "Please enter a valid PAN number.",
      });
      return;
    }

    try {
      setIsVerifying(true);

      const res = await panverify({
        panNumber: data.panNumber,
      });

      if (res?.status === "success") {
        setPanVerified(true);

        onUpdate({
          ...data,
          fullName: res.fullName,
        });

        setPopup({
          show: true,
          message: "PAN verified successfully.",
        });
      } else {
        setPopup({
          show: true,
          message: "PAN verification failed.",
        });
      }
    } catch (err) {
      setPopup({
        show: true,
        message: "Something went wrong.",
      });
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="w-full">
      <h3 className="mb-4 text-md font-semibold text-[#0A2A4F]">
        Basic Information
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

        {/* PAN FIELD */}
        <div className="md:col-span-2">
          <InputField
            label="PAN Number *"
            icon={FiHash}
            name="panNumber"
            value={data.panNumber || ""}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "panNumber",
                  value: e.target.value.toUpperCase(),
                },
              })
            }
            disabled={panVerified}
            placeholder="ABCDE1234F"
            iconRight={
              panVerified ? (
                <FiCheckCircle className="text-[#0A2A4F]" />
              ) : null
            }
          />
        </div>

        {/* VERIFY BUTTON */}
        {!panVerified && (
          <div className="md:col-span-2">
            <button
              onClick={handlePanVerify}
              disabled={isVerifying}
              className="w-full md:w-1/3 bg-[#0A2A4F] text-white py-2.5 rounded-full hover:bg-[#08305e]"
            >
              {isVerifying ? "Verifying PAN..." : "Verify PAN"}
            </button>
          </div>
        )}

        {/* AFTER PAN VERIFIED */}

        {panVerified && (
          <>
            <InputField
              label="Full Name"
              icon={FiUser}
              name="fullName"
              value={data.fullName || ""}
              disabled
            />

            <InputField
              type="date"
              label="Date of Birth *"
              icon={FiCalendar}
              name="dob"
              value={data.dob || ""}
              onChange={handleChange}
            />

            <InputField
              label="Mobile Number *"
              icon={FiPhone}
              name="mobileNumber"
              value={data.mobileNumber || ""}
              inputMode="numeric"
              onChange={(e) => {
                let value = e.target.value.replace(/\D/g, "");
                if (value.length > 10) value = value.slice(0, 10);

                handleChange({
                  target: {
                    name: "mobileNumber",
                    value,
                  },
                });
              }}
            />

            <InputField
              label="Father's Name *"
              icon={FiUser}
              name="fatherName"
              value={data.fatherName || ""}
              onChange={handleChange}
            />

            <InputField
              label="Email *"
              type="email"
              name="email"
              value={data.email || ""}
              onChange={handleChange}
            />

            <SelectField
              label="Gender *"
              name="gender"
              value={data.gender || ""}
              onChange={handleChange}
              options={[
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" },
                { value: "Other", label: "Other" },
              ]}
            />
          </>
        )}
      </div>

      {popup.show && (
        <Popup
          message={popup.message}
          onClose={() => setPopup({ show: false, message: "" })}
        />
      )}
    </div>
  );
};

export default BasicDetails;
